import './publicPath';
import React from 'react';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

const reactRender = window.wp.element.render;

reactRender(<App />, document.getElementById('js-dinner-party'));

// scroll back up to the top on page load
window.onbeforeunload = function() {
    window.scrollTo(0, 0);
};

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
